import styled from 'styled-components';

export const Main = styled.div`
   min-width: 150px;
   padding: 0;
`;

export const Styled = styled.div`
   .scroll {
      overflow: auto;
      max-height: 300px;

      .textInput {
         margin-top: 0;
      }
      .item {
         position: relative;
         padding: 15px 10px;
         border: 1px solid rgb(220, 220, 220);
         border-radius: 7.5px;

         &:not(:last-of-type) {
            margin-bottom: 10px;
         }
         .flex {
            display: flex;
            width: 100%;
            margin-bottom: 10px;

            .textInput {
               width: 100%;
            }
         }
         .remove {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 18px;
            background-color: #898FFF;
            color: #fff;
            border-radius: 5px;
            width: 45px;
            margin-left: 7.5px;
            transition: all .2s ease-in-out;

            &:hover {
               box-shadow: 0 0 10px #898FFF;
            }
         }
      }
   }
   .btn1 {
      margin: 10px 0;

      &:hover {
         box-shadow: 0 0 10px #898FFF;
      }
   }
   .textarea {
      margin-top: 10px;
   }
`;